import React from 'react';
import { useStateContext } from '../../../context/ContextProvider';



const DButton = ({ icon, bgColor, color, bgHoverColor, size, text, borderRadius, width }) => {
  const { setIsClicked, initialState } = useStateContext();

  return (
    <button
      type="button"
      onClick={() => setIsClicked(initialState)}
      style={{ backgroundColor: bgColor, color, borderRadius }}
      className={` text-${size} p-3 w-${width} hover:drop-shadow-xl font-kufi hover:bg-gray-200`}
    >
      {icon} {text}
    </button>
  );
};

export default DButton;
